import { useRouter } from 'next/router';
import styled from 'styled-components';
import i18n from 'src/utils/translate';
import { titleSmall } from 'styles-js/mixins/typography';
import { useUpdateSearchParam } from 'src/modules/search/hooks';
enum Sort {
  MostRelevant = 'most-relevant',
  Newest = 'newest',
}
export default function SortByOptions(): JSX.Element {
  const router = useRouter();
  const getLinkProps = useUpdateSearchParam('sort');
  return <Wrapper data-testid="search-sidebar-filter-options-sort" data-sentry-element="Wrapper" data-sentry-component="SortByOptions" data-sentry-source-file="sortByOptions.tsx">
      <label>
        <input checked={router.query.sort === Sort.MostRelevant || !router.query.sort} type="radio" value={Sort.MostRelevant} onChange={e => {
        const {
          as,
          href
        } = getLinkProps(e.target.value);
        router.push(href, as, {
          scroll: false
        });
      }} />
        <span>
          {i18n.t('Most Relevant')}
        </span>
      </label>
      <label>
        <input checked={router.query.sort === Sort.Newest} type="radio" value={Sort.Newest} onChange={e => {
        const {
          as,
          href
        } = getLinkProps(e.target.value);
        router.push(href, as, {
          scroll: false
        });
      }} />
        <span>
          {i18n.t('Newest')}
        </span>
      </label>
    </Wrapper>;
}
const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
  padding-top: 5px;
  h3 {
    ${titleSmall}
  }
  label {
    display: flex;
    gap: 8px;
  }
`;